export const select = [
	'address.address1',
	'address.address2',
	'address.city',
	'address.postal_code',
	'available',
	'capacity',
	'desk_price',
	'desk_type',
	'distance',
	'id',
	'images',
	'latitude',
	'longitude',
	'nearest_stations',
	'new',
	'opening_date',
	'price',
	'price_day',
	'price_day_discounted',
	'price_hour',
	'price_hour_discounted',
	'prices',
	'prices_starting_at',
	'rebate_percent',
	'slug',
	'surface',
	'title',
	'zone',
]
